import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceService, EventTrackerService } from '@app/core';
import { iBook } from '@app/interfaces/iBook';
import { IndicatorService } from '@app/shared';
import { environment } from '@env/environment';


@Component({
  selector: 'navaar-list-items',
  templateUrl: './list-items.component.html',
  styleUrls: ['./list-items.component.scss']
})
export class ListItemsComponent implements OnInit, OnDestroy {
  @Input() public title: string | null = null;
  @Input('items') public items: Array<iBook>;
  @Input('event-tracker-name') public eventTrackerName: string;
  @Input() public isEnd: boolean = false;
  @Input('disable-when-fetch-data') public isLoading: boolean = false;
  @Input('more-icon') public showIcon;
  @Input('is-show-subscription-status') public showSubscriptionStatus: false;
  @Output('go-to') public goToPage: EventEmitter<number> = new EventEmitter<number>();
  @Input('type') public _typeLeftContent: 'star' | 'menu' | 'price' | 'none';
  @Input('detail-mode') public detailMode: boolean = true;
  @Input('show-rating-number') public showRatingNumber: boolean = true;
  public readonly IMAGE_URL: string = environment.imageUrl;
  @ViewChild('TemplateWithStar', { read: TemplateRef, static: true }) private starT: TemplateRef<any>;
  @ViewChild('TemplateWithPrice', { read: TemplateRef, static: true }) private priceT: TemplateRef<any>;
  @ViewChild('TemplateWithNone', { read: TemplateRef, static: true }) private noneT: TemplateRef<any>;

  @ViewChild('star', { read: TemplateRef, static: true }) private starNonDetail: TemplateRef<any>;
  @ViewChild('price', { read: TemplateRef, static: true }) private priceNonDetail: TemplateRef<any>;
  @ViewChild('none', { read: TemplateRef, static: true }) private noneNonDetail: TemplateRef<any>;


  constructor(
    private readonly router: Router,
    private readonly eventTracker: EventTrackerService,
    private readonly indicator: IndicatorService,
    public readonly device: DeviceService) { }

  public ngOnInit() { }

  public goToBook(id, title, idx: number) {
    this.indicator.show();
    this.eventTracker.logEvent(this.eventTrackerName,
      {
        item_name: 'x_item_pdp',
        x_item_id: id,
        x_item_index: idx,
        x_item_name: title
      });
    this.router.navigate(['/audiobook', id]).then();
  }

  public ngOnDestroy(): void {
    this.indicator.hideHude();
  }

  public trackBy(index, item): any {
    return item.identifier;
  }
  public getTemplate() {
    if (this.detailMode) {
      switch (this._typeLeftContent) {
        case 'star':
          return this.starT;
        case 'price':
          return this.priceT;
        case 'menu':
          return this.noneT;
        case 'none':
        default:
          return this.noneT;
      }
    }else{
      switch (this._typeLeftContent) {
        case 'star':
          return this.starNonDetail;
        case 'price':
          return this.priceNonDetail;
        case 'menu':
        case 'none':
        default:
          return null;
      }
    }
  }
}
